// extracted by mini-css-extract-plugin
export default {"idCol":"ManifestsTab__idCol-MEhMC","targetCol":"ManifestsTab__targetCol-wGQ2Z","dateCol":"ManifestsTab__dateCol-DF7vk","editButton":"ManifestsTab__editButton-Jg5Z0"};